// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.total {
  margin: 0 0 20px 25px;
}

.total h1 {
  text-align: left;
}

.clearbutton button {
  margin-left: 0px;
  background-color: white;
  /* border-color: gray; */
  border-radius: 5px;
  height: 30px;
  cursor: pointer;
  color: black;
  border: none;
}

.clearbutton button:hover {
  background-color: white;
  color: red;
}

/* .applybutton button {
    margin-right: 2px;
    margin-left: 2px;
    right: 20px;
    height: 30px;
    width: 56px;
    background-color: white;
    border-color: gray;
    border-radius: 5px;
    cursor: pointer;
} */
.bottomButton {
  /* position: relative; */
  /* bottom: 3px; */
  background-color: white;
  display: flex;
  gap: 12px;
  justify-content: center;
  padding: 0px 10px 7px;
}

.scroll {
  position: relative;
  height: 150px;
  overflow-y: scroll;
  scroll-behavior: smooth;
}

.upperButtonGroup {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

.upperButton {
  display: flex;
  height: 35px;
  color: black;
}

.upperButton button {
  min-width: 90px;
  cursor: pointer;
  background-color: #ffffff;
  color: #666;
  border: 1px solid #dfdfdf;
  box-shadow: none;
}

.upperButton button:hover {
  background-color: #efefef;
  color: #007aff;
  border: 1px solid #007aff;
  box-shadow: none;
}

.outerDiv {
  /* padding: 10px 0px 0px 10px; */
  /* height: 200px; */
  overflow: hidden;
  position: relative;
}

.others button {
  gap: 10px;
}

.formcont {
  max-height: 160px;
  overflow: auto;
  padding: 10px 0px 0px 10px;
}

.formcont::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./components/FilterButtons/FilterButtons.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AACF;;AACA;EACE,uBAAA;EACA,UAAA;AAEF;;AACA;;;;;;;;;;GAAA;AAYA;EACE,wBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AACA;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAEF;;AACA;EACE,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAEF;;AACA;EACE,SAAA;AAEF;;AACA;EACE,iBAAA;EACA,cAAA;EACA,0BAAA;AAEF;;AAAA;EACE,UAAA;EACA,uBAAA;AAGF","sourcesContent":[".total {\n  margin: 0 0 20px 25px;\n}\n\n.total h1 {\n  text-align: left;\n}\n\n.clearbutton button {\n  margin-left: 0px;\n  background-color: white;\n  /* border-color: gray; */\n  border-radius: 5px;\n  height: 30px;\n  cursor: pointer;\n  color: black;\n  border: none;\n}\n.clearbutton button:hover {\n  background-color: white;\n  color: red;\n}\n\n/* .applybutton button {\n    margin-right: 2px;\n    margin-left: 2px;\n    right: 20px;\n    height: 30px;\n    width: 56px;\n    background-color: white;\n    border-color: gray;\n    border-radius: 5px;\n    cursor: pointer;\n} */\n\n.bottomButton {\n  /* position: relative; */\n  /* bottom: 3px; */\n  background-color: white;\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  padding: 0px 10px 7px;\n}\n\n.scroll {\n  position: relative;\n  height: 150px;\n  overflow-y: scroll;\n  scroll-behavior: smooth;\n}\n\n.upperButtonGroup {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n\n.upperButton {\n  display: flex;\n  height: 35px;\n  color: black;\n}\n\n.upperButton button {\n  min-width: 90px;\n  cursor: pointer;\n  background-color: #ffffff;\n  color: #666;\n  border: 1px solid #dfdfdf;\n  box-shadow: none;\n}\n.upperButton button:hover {\n  background-color: #efefef;\n  color: #007aff;\n  border: 1px solid #007aff;\n  box-shadow: none;\n}\n\n.outerDiv {\n  /* padding: 10px 0px 0px 10px; */\n  /* height: 200px; */\n  overflow: hidden;\n  position: relative;\n}\n\n.others button {\n  gap: 10px;\n}\n\n.formcont {\n  max-height: 160px;\n  overflow: auto;\n  padding: 10px 0px 0px 10px;\n}\n.formcont::-webkit-scrollbar {\n  width: 0px;\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
